import { Github, Google } from '@ankr.com/ui';

import { useAuth } from 'modules/auth/hooks/useAuth';

export interface OauthIconProps {
  className?: string;
}

export const OauthIcon = ({ className }: OauthIconProps) => {
  const { isGithubAuth, isOAuth } = useAuth();

  if (!isOAuth) {
    return null;
  }

  if (isGithubAuth) {
    return <Github className={className} />;
  }

  return <Google className={className} />;
};
